import axios, { AxiosError } from "axios";

let getToken: () => string | null = () => null;

export const setTokenGetter = (fn: () => string | null) => {
  getToken = fn;
};

export const api = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  config.headers = config.headers ?? {};

  const hasAuth =
    Boolean((config.headers as any).Authorization) ||
    Boolean((config.headers as any).authorization);

  if (!hasAuth) {
    const token = getToken();
    if (token) (config.headers as any).Authorization = `Bearer ${token}`;
  }

  return config;
});

export const throwApiError = (error: unknown, fallback: string): never => {
  if (axios.isAxiosError(error)) {
    const data = error.response?.data as any;

    const msg = Array.isArray(data?.message)
      ? data.message.join(" | ")
      : typeof data?.message === "string"
        ? data.message
        : fallback;

    throw new Error(msg);
  }

  throw new Error(fallback);
};
